import React from 'react';
export default function Rule() {
  return /*#__PURE__*/React.createElement("hr", {
    role: "presentation"
  });
}